import React, { useEffect, useMemo, useState, useCallback } from "react";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import DatatableFunc from "../../../Common/DatatableFunc";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";

const REQUIRED_FIELDS = ["ac", "non_ac", "bus staff", "staff"];

const List = () => {
  const location = useLocation();

  const [receiveData, setReceiveData] = useState([]);
  const [inputs] = useState({ type: "finished_goods" });
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");


  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      // const res = await Http.get(`/product-list/${inputs.type}?conversion=true`);
      const res = await Http.get(`/restaurant-finished-good?conversion=true`);
      setReceiveData(res.data || []);
    } catch (err) {
      console.error("Fetch error:", err);
    } finally {
      setLoading(false);
    }
  }, [inputs.type]);

  useEffect(() => {
    DatatableFunc();
    fetchData();
  }, [fetchData]);


  const showAlert = useCallback((message, type) => {
    const icon = type || "info";
    const titleMap = {
      success: "Success",
      error: "Error",
      warning: "Warning",
      info: "Info",
    };
    Swal.fire({
      icon,
      title: titleMap[icon] || "Info",
      text: message,
    });
  }, []);

  useEffect(() => {
    if (location.state) {
      showAlert(location.state.message, location.state.type);
    }
  }, [location, showAlert]);


  const isFinishedGoods = (item) => item.type === "finished_goods";

  const hasAnyValue = (conversion = {}) =>
    REQUIRED_FIELDS.some(
      (f) => conversion[f] !== undefined && conversion[f] !== ""
    );


  const formSubmit = () => {
    const missingFields = [];
    const conversions = [];

    for (const item of receiveData) {
      const conversion = item.conversion || {};

      if (!hasAnyValue(conversion)) continue;

      if (isFinishedGoods(item)) {
        REQUIRED_FIELDS.forEach((field) => {
          if (conversion[field] === undefined || conversion[field] === "") {
            missingFields.push(`${item.code} - ${field.toUpperCase()} is required`);
          }
        });
      }

      conversions.push({
        product_id: item.id,
        ac: conversion.ac ?? 0,
        non_ac: conversion.non_ac ?? 0,
        others: conversion.others ?? 0,
        staff: conversion.staff ?? 0,
      });
    }

    if (missingFields.length) {
      showAlert(
        `Required fields missing:\n${missingFields.join("\n")}`,
        "warning"
      );
      return;
    }

    if (!conversions.length) {
      showAlert("No conversion data to submit", "warning");
      return;
    }

    Http.post("/product-conversion", { conversions })
      .then(() => {
        showAlert("Conversion data saved successfully!", "success");
        
        fetchData();
      })
      .catch(() => showAlert("Error saving conversion data", "error"));
  };


  const handleRowInputChange = useCallback((rowId, field, value) => {
    setReceiveData((prev) =>
      prev.map((item) =>
        item.id === rowId
          ? {
              ...item,
              conversion: {
                ...(item.conversion || {}),
                [field]: value,
              },
            }
          : item
      )
    );
  }, []);


  const filteredData = useMemo(() => {
    const search = searchTerm.toLowerCase();
    return receiveData.filter(
      (item) =>
        item.code?.toLowerCase().includes(search) ||
        item.name?.toLowerCase().includes(search)
    );
  }, [receiveData, searchTerm]);


  return (
    <div>
      <IsLogin />

      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">All Finished Goods</h5>
        </div>

        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <input
              className="form-control mb-3"
              placeholder="Search by Code or Name..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />

            <div className="table-responsive" style={{ maxHeight: 500 }}>
              <table className="table table-sm table-bordered table-striped">
                <thead className="sticky-top bg-light">
                  <tr>
                    <th>Code</th>
                    {REQUIRED_FIELDS.map((f) => (
                      <th key={f}>
                        {f.replace("_", " ").toUpperCase()}{" "}
                        <span className="text-danger">*</span>
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {filteredData.map((item) => (
                    <tr key={item.id}>
                      <td>{item.label}</td>

                      {REQUIRED_FIELDS.map((field) => {
                        const val = item.conversion?.[field] ?? "";
                        const required = isFinishedGoods(item) && val === "";

                        return (
                          <td key={field}>
                            <input
                              className="form-control form-control-sm"
                              value={val}
                              placeholder={required ? "Required" : ""}
                              onChange={(e) =>
                                handleRowInputChange(
                                  item.id,
                                  field,
                                  e.target.value
                                )
                              }
                            />
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <button className="btn btn-primary mt-3 col-2 " onClick={formSubmit}>
              <i className="fa fa-save mg-r-10" /> Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default List;
